import { Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from '@shared/permission';
import { IDynamicReportType } from '../dynamic-report-general.interface';
import { DynamicReportGeneralFormComponent } from '../dynamic-report-general-form/dynamic-report-general-form.component';
import { DYNAMIC_REPORT_HTTP_LOADER, DynamicReportHttpLoader } from '../dynamic-report-http-loader.service';
import { DynamicReportGeneralDto } from '../dynamic-report-general.dto';
import { ToastService } from '@shared/components/toast';
import { DynamicReportGeneralModel } from '../dynamic-report-general.model';
import * as saveAs from 'file-saver';
import { ITableActionButton } from '@shared/components/table-action-group';
import { Confirmable } from '@shared/components/confirm-dialog';

@Component({
    selector: 'red-dynamic-report-general-detail',
    templateUrl: './dynamic-report-general-detail.component.html',
    styleUrls: ['./dynamic-report-general-detail.component.scss']
})
export class DynamicReportGeneralDetailComponent {
    @ViewChild('dynamicReportGeneralFormComponent', {
        read: DynamicReportGeneralFormComponent,
        static: true,
    }) form!: DynamicReportGeneralFormComponent;
    reportTypes: IDynamicReportType[] = [];
    reportType!: string;
    saving = false;
    reportId!: number;
    item!: DynamicReportGeneralModel;
    loadingDownload = false;

    buttons: ITableActionButton[] = [
        {
            id: 'download',
            icon: 'download',
            label: 'Download',
            hidden: (item, action) => this.isItemHidden(item, action),
            permissionSlug: '',
        },
        {
            id: 'update',
            icon: 'edit',
            label: 'Edit',
            hidden: (item, action) => this.isItemHidden(item, action),
            permissionSlug: '',
            link: (item, action) => `/dynamic-report/${item.reportType}/edit/${item.id}`,
            linkQueryParams: (item, action) => ({ reportType: item.reportType }),
            queryParamsHandling: 'merge'
        },
        {
            id: 'delete',
            icon: 'delete',
            label: 'Delete',
            hidden: (item, action) => this.isItemHidden(item, action),
            permissionSlug: '',
        },
    ];
    constructor(
        @Inject(DYNAMIC_REPORT_HTTP_LOADER) private _apiService: DynamicReportHttpLoader,
        private readonly _location: Location,
        private readonly router: Router,
        private _activatedRoute: ActivatedRoute,
        private _permissionService: PermissionsService,
        private readonly _toastService: ToastService,

    ) {
        this.reportTypes = (this._activatedRoute.snapshot.data['reportTypes'])?.filter((e: any) => e.permissionSlug && !this._permissionService.canDeny(e.permissionSlug)) ?? [];
        this.reportId = this._activatedRoute.snapshot.params['id'] * 1;
        this.item = this._activatedRoute.snapshot.data['item'];
        this.reportType = this._activatedRoute.snapshot.queryParams['reportType'] ?? this.item?.reportType;

    }

    back(): void {
        //this._location.back();
        this.router.navigate([`/dynamic-report/${this.reportType ?? 'project'}`], { queryParams: { reportType: this.reportType ?? 'project' }, replaceUrl: true, queryParamsHandling: 'merge' });
    }
    actionClick(action: ITableActionButton, item: DynamicReportGeneralModel): void {
        switch (action.id) {
            case 'download':
                this.download(item);
                break;
            case 'delete':
                this.delete(item);
                break;
        }
    }

    isItemHidden(item: DynamicReportGeneralModel, action?: ITableActionButton): boolean {
        let isHidden = false;
        const permissionSlug = action?.permissionSlug;
        isHidden = permissionSlug ? this._permissionService.canDeny(permissionSlug) : false;
        return isHidden;
    }

    @Confirmable({
        type: 'warning',
        title: 'Delete Report!',
        description: 'Are you sure to delete this report?',
    })
    delete(item: DynamicReportGeneralModel) {
        this._apiService.delete(item.id).subscribe({
            next: result => {
                this._toastService.open({ type: 'success', title: 'Success', messages: 'Report deleted successfully!' });
                this.back();
            },
            error: err => {
                this._toastService.open({
                    type: 'danger',
                    title: 'Error',
                    messages: err.message ?? 'Error occurred while deleting report!',
                });
            },
        });
    };

    download(item: DynamicReportGeneralModel): void {
        const payload = DynamicReportGeneralDto.fromJson(item);
        this.handleDisabledButtonDownload(true);
        this._apiService.export(item?.id, payload).subscribe({
            next: (res) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `${item.name}.xlsx`);
                this.handleDisabledButtonDownload(false);
            },
            error: (error) => {
                this.handleDisabledButtonDownload(false);
                this._toastService.open({
                    type: 'danger',
                    title: 'Error',
                    messages: error.message ?? 'Something went wrong',
                });
            }
        });
    }
    handleDisabledButtonDownload(isDisabled: boolean) {
        this.buttons = this.buttons.map(btn => {
            return { ...btn, disabled: btn.id === 'download' ? () => isDisabled : undefined }; // Update the button to be disabled or not
        })
    }
} 